export default "__VITE_ASSET__78vOJFmF__"